import { Swiper, Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

const fn = {
  init: () => {
    const elements = document.querySelectorAll('.housing-properties-slider')

    if (elements.length) {
      elements.forEach((el) => fn.setupSlider(el))

      window.addEventListener('resize', fn.handleControls)

      fn.handleControls()
    }
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper-container')

    if (!container) {
      return
    }

    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 1,
      pagination: {
        el: container.querySelector('.housing-properties-slider-pagination'),
        type: 'custom',
        renderCustom: function (_, current, total) {
          return `(${current}/${total})`
        },
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerColumn: 2,
          slidesPerColumnFill: 'row',
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          slidesPerColumn: 2,
          slidesPerColumnFill: 'row',
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 3,
          slidesPerColumn: 2,
          slidesPerColumnFill: 'row',
          spaceBetween: 40,
        },
      },
    }

    if (numSlides > 1) {
      opts.navigation = {
        nextEl: container.querySelector('.housing-properties-slider-button-next'),
        prevEl: container.querySelector('.housing-properties-slider-button-prev'),
      }

      new Swiper(container, opts)
    }
  },

  handleControls: () => {
    document.querySelectorAll('.housing-properties-slider .swiper-container').forEach((el) => {
      const numSlides = el.querySelectorAll('.swiper-slide').length
      const controls = el.querySelector('.housing-properties-slider-controls')

      if (numSlides < 2) {
        return
      }

      if (controls) {
        controls.classList.remove('invisible')

        if (window.matchMedia('(min-width: 768px)').matches && numSlides < 5) {
          controls.classList.add('invisible')
        }

        if (window.matchMedia('(min-width: 1024px)').matches && numSlides < 7) {
          controls.classList.add('invisible')
        }
      }
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
